import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { CatalogSettingsPanel } from "./-components/catalog-settings-panel";
import { useSkillsCatalogMutations } from "./-hooks/use-skills-catalog-mutations";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { trpc } from "~/utils/trpc";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/skills/settings")({
  component: SkillsSettingsRouteComponent,
});

function SkillsSettingsRouteComponent() {
  const { datasetSlug } = Route.useParams();
  const metaQuery = useQuery(trpc.skills.getCatalogMeta.queryOptions());
  const meta = metaQuery.data;
  const catalogMutations = useSkillsCatalogMutations();

  useBreadCrumbs([
    { title: "Skills", link: `/${datasetSlug}/data/skills` },
    { title: "Settings", link: `/${datasetSlug}/data/skills/settings` },
  ]);

  if (metaQuery.isLoading) {
    return <div className="p-6 text-sm text-muted-foreground">Loading skills workspace…</div>;
  }

  if (!meta) {
    return <div className="p-6 text-sm text-muted-foreground">Skills workspace unavailable.</div>;
  }

  return (
    <div className="space-y-4 mx-5 pb-8">
      <div className="max-w-3xl">
        <h1 className="text-2xl font-bold">Skills Settings</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Configure the shared vocabulary, link types, skill sets, and scales that define this dataset's skills catalog.
        </p>
      </div>

      <CatalogSettingsPanel datasetSlug={datasetSlug} meta={meta} {...catalogMutations} />
    </div>
  );
}
